import { createFileRoute } from '@tanstack/react-router'
import ContatoNovoPage from '@/pages/contatos/contato-novo'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Rota para criar um novo contato
// Path completo será /dashboard/$dashboardId/contatos/novo
// Renderizada dentro do <Outlet /> de dashboard.$dashboardId.contatos/route.tsx
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/contatos/novo',
)({
  component: function ContatoNovoRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.CONTATOS} dashboardId={dashboardId}>
        <ContatoNovoPage dashboardId={dashboardId} />
      </RequireModule>
    )
  },
})
